import { render } from "./Listsnovip.vue?vue&type=template&id=8adcf262&scoped=true"
import script from "./Listsnovip.vue?vue&type=script&lang=js"
export * from "./Listsnovip.vue?vue&type=script&lang=js"

import "./Listsnovip.vue?vue&type=style&index=0&id=8adcf262&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8adcf262"]])

export default __exports__